import { UserContext } from "../contexts/UserContext";
import {Navigate, Outlet } from "react-router-dom";
import { useContext } from "react";

const UnauthRoute = () => {

    const {user} = useContext(UserContext);

    return user.isLogged ? <Navigate to={'/account'} /> : <Outlet />;
}

export default UnauthRoute;